import { lazy } from 'react';

import { withSuspense } from '@/shared/lib/hocs/with-suspense.hoc';
import { PageLoader } from '@/widgets/page';

export const PrivacyPolicyPage = withSuspense(
	lazy(async () => await import('./privacy-policy-page.component')),
	PageLoader,
);
